import { render, staticRenderFns } from "./DtCostumers.vue?vue&type=template&id=c9b451e6"
import script from "./DtCostumers.vue?vue&type=script&lang=js"
export * from "./DtCostumers.vue?vue&type=script&lang=js"
import style0 from "./DtCostumers.vue?vue&type=style&index=0&id=c9b451e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports